import React from 'react';
import PropTypes from 'prop-types';
import { Table, Thead, Tr, Th, Tbody } from 'oxyrion-ui/lib/Table';
import { Loader } from 'oxyrion-ui/lib';
import { LoaderWrapper } from '../ReusableComponents';
import InfoTableRow from '../InfoTableRow';
import { connect } from '../../Store';

class InfoTable extends React.Component {
  renderHeaderCell(data, right, left, center) {
    return (
      <Th right={right} left={left} center={center}>
        {data}
      </Th>
    );
  }

  render() {
    const { headers, data, loading } = this.props;

    if (loading)
      return (
        <LoaderWrapper style={{ width: '100%' }}>
          <Loader size="xl" />
        </LoaderWrapper>
      );

    return (
      <Table>
        <Thead>
          <Tr>
            {headers.map(header => {
              return this.renderHeaderCell(
                header.data,
                header.right,
                header.left,
                header.center,
              );
            })}
          </Tr>
        </Thead>
        <Tbody>
          {data.map(row => {
            return (
              <InfoTableRow
                cells={row.cells}
                disabled={row.disabled}
                rowHover={row.rowHover}
              />
            );
          })}
        </Tbody>
      </Table>
    );
  }
}

InfoTable.propTypes = {
  loading: PropTypes.bool,
  headers: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      rowData: PropTypes.arrayOf(
        PropTypes.shape({
          cell: PropTypes.shape({
            data: PropTypes.element,
            center: PropTypes.bool,
            right: PropTypes.bool,
            colorLabel: PropTypes.string,
            flag: PropTypes.string,
          }),
          disabled: PropTypes.bool,
          rowHover: PropTypes.bool,
        }),
      ),
    }),
  ),
};

InfoTable.defaultProps = {
  headers: [],
  data: [],
  loading: false,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(InfoTable);



// WEBPACK FOOTER //
// ./src/Components/InfoTable/index.jsx